window.initRefutable = function(){
  $('.refute-indicator').hover(
    function(){
      $('[data-refutable]').removeClass('is-selected');
      $(`[data-refutable="${$(this).attr('data-refute-for')}"]`).addClass('is-selected');
    },
    function(){
      $('[data-refutable]').removeClass('is-selected');
    }
  )
}
